"use client";

import {
  usePrivy
} from "@privy-io/react-auth";

export default function PrivyTestPage() {

  const {
    ready,
    authenticated,
    user,
    login,
    logout
  } = usePrivy();

  if (!ready) {

    return (
      <main className="p-8">
        Loading Privy...
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-slate-100 p-8">

      <div className="max-w-3xl mx-auto">

        <h1 className="text-4xl font-bold mb-8">
          Privy Test
        </h1>

        {!authenticated && (

          <div className="bg-white rounded-2xl shadow p-8">

            <h2 className="text-xl font-semibold mb-4">
              Not Logged In
            </h2>

            <button
              onClick={login}
              className="px-6 py-3 bg-blue-600 text-white rounded-xl"
            >
              Login With Privy
            </button>

          </div>

        )}

        {authenticated && (

          <div className="bg-white rounded-2xl shadow p-8">

            <h2 className="text-xl font-semibold mb-4">
              Logged In
            </h2>

            <pre className="bg-slate-100 p-4 rounded-xl overflow-auto text-sm">
              {JSON.stringify(
                user,
                null,
                2
              )}
            </pre>

            <button
              onClick={logout}
              className="mt-6 px-6 py-3 bg-red-600 text-white rounded-xl"
            >
              Logout
            </button>

          </div>

        )}

      </div>

    </main>
  );
}